"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@headlessui/react");

var _walletButton = require("./walletButton");

var _ProvideWallet = require("../context/ProvideWallet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
      closeModal = _ref.closeModal;
  return /*#__PURE__*/_react.default.createElement(_react2.Transition, {
    appear: true,
    show: isOpen,
    as: _react.Fragment
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog, {
    as: "div",
    className: "ws-bg-gray-300 ws-bg-opacity-25 ws-fixed ws-inset-0 z-10 ws-overflow-y-auto",
    onClose: closeModal
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog.Overlay, {
    className: "ws-fixed ws-inset-0 ws-bg-black ws-bg-opacity-25"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ws-min-h-screen ws-px-4 ws-text-center"
  }, /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/_react.default.createElement(_react2.Dialog.Overlay, {
    className: "ws-fixed inset-0"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ws-inline-block ws-h-screen ws-align-middle",
    "aria-hidden": "true"
  }, "\u200B"), /*#__PURE__*/_react.default.createElement(_react2.Transition.Child, {
    as: _react.Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 scale-95",
    enterTo: "opacity-100 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 scale-100",
    leaveTo: "opacity-0 scale-95"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ws-bg-gray-100 ws-inline-block ws-w-full ws-max-w-lg ws-p-6 ws-my-8 ws-overflow-hidden ws-text-left ws-align-middle ws-transition-all ws-transform ws-bg-white ws-border ws-shadow-xl ws-rounded-2xl"
  }, /*#__PURE__*/_react.default.createElement(ModalContent, {
    closeModal: closeModal
  }))))));
};

exports.Modal = Modal;

var ModalContent = function ModalContent(_ref2) {
  var closeModal = _ref2.closeModal;

  var _useWallet = (0, _ProvideWallet.useWallet)(),
      setWallet = _useWallet.setWallet,
      getWallets = _useWallet.getWallets;

  var _onClick = function onClick(walletInfo) {
    setWallet(walletInfo);
    closeModal(walletInfo);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react2.Dialog.Title, {
    as: "h3",
    className: "ws-text-lg ws-font-medium ws-leading-6 ws-text-gray-900"
  }, "Select wallet"), /*#__PURE__*/_react.default.createElement("div", {
    className: "ws-grid ws-grid-cols-2 ws-gap-8 ws-mt-4"
  }, getWallets().map(function (wallet) {
    return !!wallet ? /*#__PURE__*/_react.default.createElement(_walletButton.WalletButton, {
      key: wallet.id,
      info: wallet,
      onClick: function onClick() {
        return _onClick(wallet);
      }
    }) : null;
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "ws-text-xsm ws-text-gray-500 ws-bold ws-text-center ws-pt-5"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "ws-hover:underline",
    href: "https://xbacked.io",
    target: "_blank"
  }, "Built by xBacked")), /*#__PURE__*/_react.default.createElement("div", {
    className: "ws-hidden"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "ws-inline-flex ws-justify-center ws-px-4 ws-py-2 ws-text-sm ws-font-medium ws-text-red-900 ws-bg-red-100 ws-border ws-border-transparent ws-rounded-md ws-hover:bg-red-200 ws-focus:outline-none ws-focus-visible:ring-2 ws-focus-visible:ring-offset-2 ws-focus-visible:ring-red-500",
    onClick: closeModal
  }, "Cancel")));
};

var _default = Modal;
exports.default = _default;